module.exports = __webpack_public_path__ + "static/media/Dual-Continuum-Model-Mental-Health-Illness@3x.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/MentalModal/img/Dual-Continuum-Model-Mental-Health-Illness@3x.png
// module id = 477
// module chunks = 0